import * as React from 'react';
import SelectInput from './SelectInput';
import SelectMenu from './SelectMenu';
import { classes, style } from 'typestyle';
import fitMenuToScreen from './utils';
import OutsideActionsNotifier from '../../../helpers/OutsideActionsNotifier';
class SelectInputControl extends React.Component {
    constructor(props) {
        super(props);
        this.handleOpened = () => {
            this.setState({ opened: true });
        };
        this.handleClosed = () => {
            this.setState({ opened: false });
        };
        this.handleChange = (value) => {
            const { onChange } = this.props;
            this.handleClosed();
            const title = this.getOptionTitleByValue(value);
            onChange && onChange(value, title);
        };
        this.getOptionTitleByValue = (value) => {
            let text = undefined;
            const option = this.getOptionByValue(value);
            if (option) {
                text = option.title;
            }
            return text;
        };
        this.getOptionByValue = (value) => {
            const { menuItems } = this.props;
            let option = undefined;
            if (React.Children.count(menuItems)) {
                React.Children.forEach(menuItems, (child) => {
                    if (React.isValidElement(child) && child.props) {
                        const props = child.props;
                        if (props.value === value) {
                            option = props;
                        }
                    }
                });
            }
            return option;
        };
        this.fitMenuOnScreen = (ref) => {
            setTimeout(() => {
                ref && ref.current && fitMenuToScreen(ref.current);
            }, 100);
        };
        this.state = {
            opened: !!props.opened,
        };
    }
    render() {
        const { name, title, placeholder, value, icon, dropdownButton, errorMessage, className, isInvalid = false, disabled = false, zIndex = 2, menuItems, } = this.props;
        const { opened } = this.state;
        const inputValue = this.getOptionTitleByValue(value || '');
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes('ta-select-container', selectContainerStyle, className) },
                React.createElement(SelectInput, { name: name, isInvalid: isInvalid, errorMessage: errorMessage, value: inputValue, title: title, icon: icon, dropdownButton: dropdownButton, placeholder: placeholder, onClick: !opened ? this.handleOpened : this.handleClosed, disabled: disabled, active: opened }),
                opened && menuItems && (React.createElement("div", { ref: ref => this.fitMenuOnScreen({ current: ref }), className: classes('select-menu-items-container', menuItemsContainerStyle, style({ zIndex })) },
                    React.createElement(OutsideActionsNotifier, { onClick: () => this.handleClosed(), onTouch: () => this.handleClosed(), onScroll: () => this.handleClosed() },
                        React.createElement(SelectMenu, { selectedId: value, onChange: this.handleChange }, menuItems)))))));
    }
}
export default SelectInputControl;
const selectContainerStyle = style({
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
});
const menuItemsContainerStyle = style({
    position: 'absolute',
    width: '100%',
    zIndex: 2,
    visibility: 'hidden',
});
//# sourceMappingURL=SelectInputControl.js.map